import { Map } from 'immutable';

export default Map({
  loading: false,
  saveLoading: false,
  data: null,
});
